// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"106":"1ae8f1e8","370":"ea0f542c","415":"fb673eca","943":"2fb43810"}[chunkId] + ".css";
};